import styled from 'styled-components'

export const TableContainer = styled.div`
  overflow: visable;
  position: relative;
  height: 100%;
  width: 100%;
  border-top: ${(props) => (props.borderTop ? '1px solid #dedede' : 'none')};

  & th {
    padding: 5px !important;
  }

  & .table {
    padding: 0;
    margin: 0;
    box-shadow: none;
    border-top: none;
    border-left: none;
    border-right: none;
  }

  & .ms-Viewport {
    position: ${(props) => (props.viewPortAbsolute ? 'absolute' : 'none')};
  }
`

export const FlexTableChild = styled.div`
  flex: 1;
  overflow: auto;

  & .segment {
    padding: 0;
    overflow: auto;
  }
`
